import React from 'react';
import { InfluencerPartnershipContainer } from '../../components/Influencer/InfluencerPartnershipContainer';

export const BuzzBridgeLandingPage: React.FC = () => {
    return <InfluencerPartnershipContainer isLandingPage />;
};
